import {
  addDays,
  eachQuarterOfInterval,
  endOfYesterday,
  format,
  getQuarter,
  lastDayOfQuarter,
  max,
  parse,
  startOfQuarter,
  startOfDay,
  startOfYesterday,
  differenceInDays,
} from 'date-fns';

const quarterDisplayFormat = 'MMM dd';
const firstBenchmarksQuarterStart = new Date(2020, 1, 1);
const utcModifiedFormat = 'dd MMM yyyy HH:mm:ss';

export const getLocalDateFromUnixTimestamp = (unixTimestamp) => {
  const localDate = new Date(unixTimestamp * 1000);

  const utcStrippedString = localDate.toUTCString()
    .substring(5)
    .replace(' GMT', '');

  return parse(utcStrippedString, utcModifiedFormat, new Date());
};

export const getDefaultDashboardDates = (brand) => {
  const defaultStart = addDays(startOfYesterday(), -30);

  const isUseDefaultStart = brand === undefined
    || brand === null
    || brand.createdAt === undefined
    || brand.createdAt === null;

  const start = isUseDefaultStart
    ? defaultStart
    : max([defaultStart, startOfDay(new Date(brand.createdAt))]);

  return {
    start: start,
    end: endOfYesterday(),
    comparisonRange: getLastQuarter(),
  };
};

export const getLastQuarter = () => {
  const predefinedQuarters = getPredefinedQuarters();
  const lastQuarter = predefinedQuarters[predefinedQuarters.length - 1];

  return {
    start: lastQuarter.range.start,
    end: lastQuarter.range.end,
    predefinedQuarterValue: lastQuarter.value,
  };
};

export const getPredefinedQuarters = () => {
  const availableQuarters = getAvailableQuarters();

  return availableQuarters.map((quarterStart, index) => {
    const quarterEnd = lastDayOfQuarter(quarterStart);

    return {
      range: {
        start: quarterStart,
        end: quarterEnd,
      },
      key: getQuarterDisplay(quarterStart, quarterEnd),
      value: index,
    };
  });
};

export const getFormattedDateRange = (start, end) => {
  return {
    start: format(start, 'yyyy-MM-dd'),
    end: format(end, 'yyyy-MM-dd'),
  };
};

export const getNumberOfDays = (dateRange) => {
  return differenceInDays(dateRange.end, dateRange.start);
};

const getAvailableQuarters = () => {
  const endOfLastQuarter = addDays(startOfQuarter(Date.now()), -1);

  return eachQuarterOfInterval({
    start: firstBenchmarksQuarterStart,
    end: endOfLastQuarter,
  });
};

const getQuarterDisplay = (quarterStart, quarterEnd) => {
  const quarterNum = getQuarter(quarterStart);
  const year = quarterStart.getFullYear();
  const formattedStart = formatQuarter(quarterStart);
  const formattedEnd = formatQuarter(quarterEnd);

  return `Q${quarterNum} ${year} (${formattedStart} - ${formattedEnd})`;
};

const formatQuarter = (date) => {
  return format(date, quarterDisplayFormat);
};
